import { render, staticRenderFns } from "./CreateProjectGatesStructure.vue?vue&type=template&id=ed7ea954&scoped=true"
import script from "./CreateProjectGatesStructure.vue?vue&type=script&lang=js"
export * from "./CreateProjectGatesStructure.vue?vue&type=script&lang=js"
import style0 from "./CreateProjectGatesStructure.vue?vue&type=style&index=0&id=ed7ea954&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed7ea954",
  null
  
)

export default component.exports